export default __webpack_public_path__ + "static/media/geofence-settings.1c5284b6.svg";